import { useQuery } from '@apollo/client';
import { GET_ADMIN_PULSE } from '../graphql/Queries';

export interface AdminPulseData {
  adminPulse: {
    success: boolean;
    errors?: string[];
    classicTodayWins: number;
    casualTodayWins: number;
    classicYesterdayWins: number | null;
    casualYesterdayWins: number | null;
    dau: number;
    newPlayersToday: number;
  };
}

export function useAdminPulse() {
  return useQuery<AdminPulseData>(GET_ADMIN_PULSE);
}
